import { Genders } from '@medone/medonehp-api-client';

// Display labels for the Genders value set, mirroring the backend [EnumMember] strings.
//
// This is deliberately a Record<Genders, string> rather than a lookup through getEnumValue: that helper
// returns the enum MEMBER NAME, which is only presentable while every name happens to read as English.
// AskedDeclined broke that assumption (SCRUM-1303) and would have rendered raw to a clinician. Typing the
// map exhaustively makes the next added member a compile error in this one file instead of a silent
// display defect spread across every screen that shows a gender.
export const GENDER_LABELS: Record<Genders, string> = {
    [Genders.Male]: 'Male',
    [Genders.Female]: 'Female',
    [Genders.Unknown]: 'Unknown',
    [Genders.AskedDeclined]: 'Asked but declined',
};

// An out-of-range value → null so callers render an empty cell, not a number.
export const genderLabel = (gender: Genders | null | undefined): string | null => (gender == null ? null : GENDER_LABELS[gender] ?? null);
